const getQueryParamByKey = (key)=>{
    const query = window.location.search.substring(1);
    const params = query.split('&');
    for(let i = 0; i < params.length; i++){
        const pair = params[i].split('=');
        if (decodeURIComponent(pair[0]) === key) {
            return decodeURIComponent(pair[1]);
        }
    }
};

export { getQueryParamByKey };
//# sourceMappingURL=get-query-param-by-key.js.map
